import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

let client = null;

if (url && anonKey) {
  client = createClient(url, anonKey, {
    auth: { persistSession: false },
    realtime: { params: { eventsPerSecond: 5 } },
  });
} else if (typeof window !== 'undefined') {
  console.warn('Supabase env vars missing — Corner Chat realtime disabled.');
}

export const supabase = client;
export const isSupabaseConfigured = () => client !== null;
